/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";
import { Text, theme } from "@nordcloud/gnui";
import { ButtonWrap } from "~/components";

type WrapperProps = React.ComponentProps<typeof ButtonWrap> & {
  active: boolean;
};

const Wrapper = styled(ButtonWrap)<WrapperProps>(
  {
    display: "flex",
    flexDirection: "column",
    placeItems: "center",
    width: "100%",
    padding: theme.spacing.spacing04,
    backgroundColor: theme.color.background.ui03,
    cursor: "pointer",
    transition: "background-color 0.3s ease",
    border: "1px solid transparent",
    "&:hover": {
      backgroundColor: theme.color.background.ui04,
    },
  },
  ({ active }) => ({
    backgroundColor: active
      ? theme.color.background.ui04
      : theme.color.background.ui03,
    borderColor: active
      ? theme.color.border.focus
      : theme.color.border.border01,
    filter: active ? "none" : "grayscale(100%)",
  })
);

type Props = {
  label?: string;
  caption?: string;
  icon: React.ReactNode;
  active?: boolean;
  onClick?: () => void;
};

export function IconBox({
  icon,
  label,
  caption,
  active = false,
  onClick,
}: Props) {
  return (
    <Wrapper onClick={onClick} type="button" active={active}>
      <div css={{ marginBottom: theme.spacing.spacing02 }}>{icon}</div>
      <Text size="md" weight="medium" mb={0}>
        {label}
      </Text>
      <Text size="sm" mb={0}>
        {caption}
      </Text>
    </Wrapper>
  );
}
